"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockerContract = void 0;
const bignumber_js_1 = require("bignumber.js");
const configs_1 = require("@teleportdao/configs");
const abis_1 = require("../../abis");
const contract_base_1 = __importDefault(require("../contract-base"));
const { addressTypesNumber, addressTypes } = configs_1.bitcoinAddressTypes;
class LockerContract extends contract_base_1.default {
    constructor(connectionConfig, contractAddress) {
        super(connectionConfig, contractAddress, abis_1.LockersLogicABI);
    }
    isLocker(lockingScript) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.isLocker(lockingScript).call();
        });
    }
    isLockerActive(targetAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.isLockerActive(targetAddress).call();
        });
    }
    getLockerTargetAddress(lockingScript) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.getLockerTargetAddress(lockingScript).call();
        });
    }
    getLockerPercentageFee() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.lockerPercentageFee().call();
        });
    }
    getLockerCapacity(targetAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.getLockerCapacity(targetAddress).call();
        });
    }
    getMinRequiredTNTLockedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.minRequiredTNTLockedAmount().call();
        });
    }
    getMinRequiredTSTLockedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.minRequiredTNTLockedAmount().call();
        });
    }
    isValidLocker(lockingScript, targetAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const hexLockerScript = `0x${lockingScript.replace("0x", "")}`;
            const address = yield this.getLockerTargetAddress(hexLockerScript);
            const isLocker = yield this.isLocker(hexLockerScript);
            return isLocker && address === targetAddress;
        });
    }
    getCollateralTokenInfo(targetAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const collateralToken = yield this.contract.methods.lockerCollateralToken(targetAddress).call();
            const collateralDecimal = yield this.contract.methods.collateralDecimal(targetAddress).call();
            return { collateralToken, collateralDecimal: +collateralDecimal.toString() };
        });
    }
    getLockerReliabilityFactor(targetAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.lockerReliabilityFactor(targetAddress).call();
        });
    }
    getLockerInfo(targetAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const { lockerLockingScript, lockerRescueType, lockerRescueScript, TSTLockedAmount, collateralTokenLockedAmount, netMinted, slashingTeleBTCAmount, reservedCollateralTokenForSlash, isLocker, isCandidate, isScriptHash, } = yield this.contract.methods.lockersMapping(targetAddress).call();
            const isActive = isLocker && (yield this.isLockerActive(targetAddress));
            return {
                lockerLockingScript,
                lockerRescueType: addressTypes[+lockerRescueType.toString()],
                lockerRescueScript,
                TSTLockedAmount,
                collateralTokenLockedAmount,
                netMinted,
                slashingTeleBTCAmount,
                reservedCollateralTokenForSlash,
                isLocker,
                isCandidate,
                isScriptHash,
                isActive,
            };
        });
    }
    requestToBecomeLocker({ lockerLockingScript, lockedCollateralToken, lockedTSTAmount, lockedCollateralTokenAmount, lockerRescueType, lockerRescueScript, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethodNoError("requestToBecomeLocker", lockedCollateralToken === "0x0000000000000000000000000000000000000001"
                ? (0, bignumber_js_1.BigNumber)(lockedCollateralTokenAmount).toString()
                : "0", [
                lockerLockingScript,
                lockedCollateralToken,
                lockedTSTAmount,
                lockedCollateralTokenAmount,
                addressTypesNumber[lockerRescueType],
                lockerRescueScript,
            ]);
        });
    }
    requestInactivation(nonce = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethodNoError("requestInactivation", "0");
        });
    }
    selfRemoveLocker(nonce = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethodNoError("selfRemoveLocker", "0", []);
        });
    }
    addCollateral({ targetAddress = this.currentAccount, nativeTokenAmount, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethodNoError("addCollateral", "0", [targetAddress, nativeTokenAmount]);
        });
    }
    removeCollateral({ nativeTokenAmount, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethodNoError("removeCollateral", "0", [nativeTokenAmount]);
        });
    }
}
exports.LockerContract = LockerContract;
exports.default = LockerContract;
//# sourceMappingURL=locker-contract-interface.js.map